export const DEFAULT_BOUNDS = {
    sw: {
        lat: 49.5294835476,
        lng: 2.51357303225,
    },
    ne: {
        lat: 51.4750237087,
        lng: 6.15665815596,
    },
};

export const DEFAULT_BOUNDS_GLASSES_PILOT = {
    sw: {
        lat: 50.722647,
        lng: 2.561463,
    },
    ne: {
        lat: 51.389217,
        lng: 3.97658,
    },
};

export const MAP_STYLES: google.maps.MapTypeStyle[] = [
    {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
];

export const icons = {
    cluster: 'https://grandvision.s3.amazonaws.com/pblx/images/gnl-cluster.svg',
    marker: 'https://grandvision.s3.amazonaws.com/pblx/images/pearle-marker.svg',
    markerHover:
        'https://grandvision.s3.amazonaws.com/pblx/images/pearle-marker-white.svg',
    currentPosition:
        'https://grandvision.s3.amazonaws.com/pblx/images/user-location.svg',
};
